import { SurveysDimension } from "../../../constants";
import cx from 'classnames';
import * as React from 'react';
import { isFiniteNumber } from '../../../utils/checks';
import Styles from "./SurveysValueViewChart.css";

var Indicator = function Indicator(_a) {
  var value = _a.value,
      dimension = _a.dimension;

  var _b, _c;

  return React.createElement("span", {
    className: cx(Styles.indicator, (_b = {}, _b[Styles.active] = isFiniteNumber(value) && value > 50, _b))
  }, React.createElement("span", {
    style: {
      display: 'inline-flex'
    }
  }, isFiniteNumber(value) ? React.createElement("span", {
    className: cx(Styles.value, (_c = {}, _c[Styles.negative] = dimension === SurveysDimension.NEGATIVE, _c[Styles.positive] = dimension === SurveysDimension.POSITIVE, _c))
  }, Math.round(value)) : React.createElement("span", {
    className: cx(Styles.value, Styles.empty)
  }, '/'), React.createElement("span", {
    className: Styles.suffix
  }, "%")), React.createElement("span", {
    className: Styles.dimension
  }, dimension));
};

export default Indicator;